<div id="layoutHome" class="web-center" style="margin-top: 40px; margin-bottom: 40px;">
    <div class="row" style="display: flex; justify-content: center; margin-bottom: 20px;">
        <div class="col-md-8 web-left" style="padding: 40px;">
            
            <p><strong><span style="font-size:16pt;">Our Terms & Conditions ("T&Cs")</span></strong></p>
            <p>
                <strong><span style="font-size:10pt;">Effective Date:</span></strong> 21 December 2025
                <br>
                <strong><span style="font-size:10pt;">Last Updated:</span></strong> 01 January 2026
            </p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">1. Introduction</span></strong></p>
            <p><span style="font-size:10pt;">These Terms & Conditions (“Terms”) govern the purchase of meals, products and services offered under the Nutrigenic brand through our website, mobile platforms, or other ordering channels.</span></p>
            <p><span style="font-size:10pt;">By placing an order with Nutrigenic, you confirm that:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">You are at least 18 years of age</span></p></li>
                <li><p><span style="font-size:10pt;">You agree to be bound by these Terms</span></p></li>
                <li><p><span style="font-size:10pt;">You provide accurate and truthful information when placing orders</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">These Terms apply to all purchases made through our website, mobile application, or other ordering platforms.</span></p>
            <p><span style="font-size:10pt;">We may update these Terms from time to time. The most current version will always be available on our website. Continued use of our services after updates constitutes acceptance of the revised Terms.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">2. Information About Us</span></strong></p>
            <p><span style="font-size:10pt;">The Nutrigenic brand and services are operated by:</span></p>

            <p>
                <strong><span style="font-size:10pt;">Company Name:</span></strong> Nutrigenic Group Ltd<br>
                <strong><span style="font-size:10pt;">Trading Name:</span></strong> Nutrigenic
            </p>

            <p><strong><span style="font-size:10pt;">Registered Office:</span></strong><br>
            <span style="font-size:10pt;">6th Floor, Amp House, Dingwall Road<br>Croydon, United Kingdom, CR0 2LX</span></p>

            <p><strong><span style="font-size:10pt;">Company Number:</span></strong> 16586665</p>

            <p><span style="font-size:10pt;">Throughout these Terms: </span></p>
            <ul>
                <li><p><span style="font-size:10pt;">“Nutrigenic”, “we”, “us”, or “our” refers to Nutrigenic Group Ltd trading as Nutrigenic</span></p></li>
                <li><p><span style="font-size:10pt;">“you” or “your” refers to the customer purchasing products from us.</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">For enquiries please contact:</span></p>

            <p><strong><span style="font-size:10pt;">Email:</span></strong> <a href="mailto:support@nutrigenic.co.uk" style="color: orange;"> support@nutrigenic.co.uk</a></p>


            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">3. Orders</span></strong></p>
            <p><span style="font-size:10pt;">When placing an order:</span></p>

            <ol>
                <li><p><span style="font-size:10pt;">You select your meals or meal plan.</span></p></li>
                <li><p><span style="font-size:10pt;">You confirm your order and complete payment.</span></p></li>
                <li><p><span style="font-size:10pt;">You receive an order confirmation email.</span></p></li>
            </ol>

            <p><span style="font-size:10pt;">Once we confirm your order, a legally binding contract is formed between you and Nutrigenic.</span></p>
            <p><span style="font-size:10pt;">We reserve the right to reject or cancel orders where:</span></p>

            <ul>
                <li><p><span style="font-size:10pt;">Payment cannot be processed</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery is not available to your address</span></p></li>
                <li><p><span style="font-size:10pt;">Products are unavailable</span></p></li>
                <li><p><span style="font-size:10pt;">Pricing errors occur</span></p></li>
                <li><p><span style="font-size:10pt;">Fraud or misuse is suspected</span></p></li>
            </ul>

             <p><span style="font-size:10pt;">If an order is cancelled by us, any payment taken will be refunded.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">4. Subscription Service</span></strong></p>
            <p><span style="font-size:10pt;">Nutrigenic operates exclusively as a subscription-based meal delivery service.</span></p>
            <p><span style="font-size:10pt;">By placing an order with Nutrigenic, you agree to enrol in a recurring weekly subscription for meal deliveries.</span></p>
            <p><span style="font-size:10pt;">Subscriptions automatically renew each week unless cancelled in accordance with these Terms.</span></p>

            <br>

            <p><strong><span style="font-size:12pt;">4.1 Minimum Commitment for Promotional Offers</span></strong></p>
            <p><span style="font-size:10pt;">Some promotional offers, introductory discounts, or special pricing may require a minimum commitment period of two (2) consecutive weeks.</span></p>
            <p><span style="font-size:10pt;">If a promotional offer is applied:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">You agree to receive and pay for at least two weeks of deliveries</span></p></li>
                <li><p><span style="font-size:10pt;">Cancellation will only be permitted after the second delivery has been completed</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">If a customer cancels before completing the minimum commitment period, Nutrigenic reserves the right to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Charge the standard non-discounted price for meals already delivered; or</span></p></li>
                <li><p><span style="font-size:10pt;">Recover the value of the promotional discount applied</span></p></li>
            </ul>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.2 Subscription Payments</span></strong></p>
            <p><span style="font-size:10pt;">By subscribing you authorise Nutrigenic to automatically charge your payment method for each weekly delivery.</span></p>
            <p><span style="font-size:10pt;">Payments are typically processed before each delivery cycle.</span></p>
            <p><span style="font-size:10pt;">If payment fails, we may:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">Retry the payment</span></p></li>
                <li><p><span style="font-size:10pt;">Suspend deliveries</span></p></li>
                <li><p><span style="font-size:10pt;">Request updated payment details</span></p></li>
                <li><p><span style="font-size:10pt;">Cancel the subscription</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Customers remain responsible for payment for any meals already prepared or delivered.</span></p>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.3 Cancelling Your Subscription</span></strong></p>
            <p><span style="font-size:10pt;">After any applicable minimum commitment period has been completed, customers may cancel their subscription through their account settings.</span></p>
            <p><span style="font-size:10pt;">Cancellation must be completed before the weekly order cut-off deadline to prevent charges for the next delivery.</span></p>
            <p><span style="font-size:10pt;">Orders that have already been prepared or dispatched cannot be cancelled.</span></p>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.4 Skipping Deliveries</span></strong></p>
            <p><span style="font-size:10pt;">Customers may skip or pause deliveries through their account dashboard before the weekly cut-off time.</span></p>
            <p><span style="font-size:10pt;">Skipping deliveries does not cancel the subscription.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">5. Pricing</span></strong></p>
            <p><span style="font-size:10pt;">Prices for meals and services are displayed on our website and may change from time to time.</span></p>
            <p><span style="font-size:10pt;">Prices include VAT where applicable but may exclude delivery charges.</span></p>            
            <p><span style="font-size:10pt;">Price changes will not affect orders that have already been confirmed.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">6. Payments</span></strong></p>
            <p><span style="font-size:10pt;">Accepted payment methods may include:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Debit cards</span></p></li>
                <li><p><span style="font-size:10pt;">Credit cards</span></p></li>
                <li><p><span style="font-size:10pt;">Online payment services</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Nutrigenic does not store full card details.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">7. Promotions, Discounts & Referral Codes</span></strong></p>

            <p><span style="font-size:10pt;">Promotions, discount codes, and referral rewards:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">May have expiry dates</span></p></li>
                <li><p><span style="font-size:10pt;">Cannot normally be combined</span></p></li>
                <li><p><span style="font-size:10pt;">Cannot be exchanged for cash</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Nutrigenic reserves the right to withdraw or modify promotional offers at any time.</span></p>
            <p><span style="font-size:10pt;">Accounts suspected of abusing promotions may be suspended or terminated.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">8. Fraud & Misuse</span></strong></p>

            <p><span style="font-size:10pt;">We reserve the right to suspend or terminate accounts where we suspect:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">Fraudulent activity</span></p></li>
                <li><p><span style="font-size:10pt;">Chargeback abuse</span></p></li>
                <li><p><span style="font-size:10pt;">Misuse of promotional offers</span></p></li>
                <li><p><span style="font-size:10pt;">Creation of multiple accounts to obtain discounts</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Where misuse occurs, Nutrigenic reserves the right to recover any financial losses</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">9. Chargebacks</span></strong></p>

            <p><span style="font-size:10pt;">Customers agree to contact Nutrigenic directly to resolve any disputes before initiating a chargeback with their payment provider. </span></p>

            <p><span style="font-size:10pt;">Where a chargeback is raised without first contacting us, we reserve the right to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Suspend the account</span></p></li>
                <li><p><span style="font-size:10pt;">Recover associated administrative costs</span></p></li>
                <li><p><span style="font-size:10pt;">Refuse future orders</span></p></li>
            </ul>
            
            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">10. Products</span></strong></p>

            <p><span style="font-size:10pt;">We make every effort to ensure our product descriptions and nutritional information are accurate.</span></p>
            <p><span style="font-size:10pt;">However:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">Food appearance may vary</span></p></li>
                <li><p><span style="font-size:10pt;">Ingredient availability may change</span></p></li>
                <li><p><span style="font-size:10pt;">Portion sizes may vary slightly</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">We reserve the right to substitute ingredients where necessary while maintaining meal quality.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">11. Food Safety & Storage  </span></strong></p>

            <p><span style="font-size:10pt;">Nutrigenic prepares meals in accordance with UK Food Standards Agency guidelines.</span></p>
            <p><span style="font-size:10pt;">Customers must:</span></p>

            <ul>
                <li><p><span style="font-size:10pt;">Refrigerate meals immediately</span></p></li>
                <li><p><span style="font-size:10pt;">Store meals at 0–5°C</span></p></li>
                <li><p><span style="font-size:10pt;">Consume meals before the use-by date</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Failure to store meals correctly may affect food safety.</span></p>
            <p><span style="font-size:10pt;">Nutrigenic is not responsible for issues resulting from improper storage</span></p>

            <br>
            
            <p><strong><span style="font-size:16pt;">12. Heating Instructions</span></strong></p>

            <p><span style="font-size:10pt;">Meals should be reheated according to the instructions provided on packaging</span></p>
            <p><span style="font-size:10pt;">Customers should ensure meals are heated until piping hot throughout before consumption.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">13. Allergens</span></strong></p>

            <p><span style="font-size:10pt;">Our kitchen handles ingredients that may contain:</span></p>

            <ul>
                <li><p><span style="font-size:10pt;">Nuts</span></p></li>
                <li><p><span style="font-size:10pt;">Dairy</span></p></li>
                <li><p><span style="font-size:10pt;">Eggs</span></p></li>
                <li><p><span style="font-size:10pt;">Gluten</span></p></li>
                <li><p><span style="font-size:10pt;">Soy</span></p></li>
                <li><p><span style="font-size:10pt;">Fish</span></p></li>
                <li><p><span style="font-size:10pt;">Sesame</span></p></li>
                <li><p><span style="font-size:10pt;">Mustard</span></p></li>
                <li><p><span style="font-size:10pt;">Celery</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Although precautions are taken, we cannot guarantee allergen-free meals.</span></p>
            <p><span style="font-size:10pt;">Customers with allergies must review ingredient information before ordering.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">14. Delivery</span></strong></p>

            <p><span style="font-size:10pt;">Nutrigenic delivers to selected areas within the United Kingdom.</span></p>
            <p><span style="font-size:10pt;">Delivery times are estimates and may vary due to circumstances outside our control.</span></p>
            <p><span style="font-size:10pt;">Customers must provide:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Accurate delivery address</span></p></li>
                <li><p><span style="font-size:10pt;">Valid contact details</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery instructions where required</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">Once delivery has been completed, responsibility for the meals transfers to the customer.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">15. Missed Deliveries</span></strong></p>

            <p><span style="font-size:10pt;">If delivery cannot be completed due to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Incorrect address details</span></p></li>
                <li><p><span style="font-size:10pt;">Lack of access</span></p></li>
                <li><p><span style="font-size:10pt;">Customer unavailability</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">Nutrigenic cannot guarantee redelivery or refunds.</span></p>
            <p><span style="font-size:10pt;">Customers are responsible for ensuring delivery information is correct.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">16. Refunds & Complaints</span></strong></p>

            <p><span style="font-size:10pt;">If there is an issue with your order, please contact us within 24 hours of delivery.</span></p>
            <p><span style="font-size:10pt;">Refunds or account credits may be issued where:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Meals arrive damaged</span></p></li>
                <li><p><span style="font-size:10pt;">Items are missing</span></p></li>
                <li><p><span style="font-size:10pt;">Products are unsafe to consume</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery fails due to our error</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">Customers may be asked to provide photographs or additional information.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">17. Perishable Products</span></strong></p>

            <p><span style="font-size:10pt;">Because Nutrigenic meals are fresh and perishable, the standard 14-day cancellation right under UK consumer law does not apply after delivery. </span></p>
            <p><span style="font-size:10pt;">Orders may only be cancelled before the weekly order cut-off deadline. </span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">18. Business Customers</span></strong></p>

            <p><span style="font-size:10pt;">Customers purchasing meals for business purposes are not entitled to the same rights as consumers.</span></p>
            <p><span style="font-size:10pt;">Business customers cannot cancel orders once accepted and are not entitled to the same refund protections</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">19. Limitation of Liability</span></strong></p>

            <p><span style="font-size:10pt;">To the fullest extent permitted by law, Nutrigenic shall not be liable for: </span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Loss of profits</span></p></li>
                <li><p><span style="font-size:10pt;">Loss of revenue</span></p></li>
                <li><p><span style="font-size:10pt;">Loss of business</span></p></li>
                <li><p><span style="font-size:10pt;">Indirect or consequential losses</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">Our liability will not exceed the total value of the order purchased.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">20. Liability We Cannot Exclude</span></strong></p>

            <p><span style="font-size:10pt;">Nothing in these Terms excludes liability for:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Death or personal injury caused by negligence</span></p></li>
                <li><p><span style="font-size:10pt;">Fraud or fraudulent misrepresentation</span></p></li>
                <li><p><span style="font-size:10pt;">Rights granted under UK consumer law</span></p></li>
            </ul>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">21. Events Outside Our Control</span></strong></p>

            <p><span style="font-size:10pt;">Nutrigenic is not responsible for delays or failure to deliver caused by events outside our reasonable control including: </span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Severe weather</span></p></li>
                <li><p><span style="font-size:10pt;">Transport disruption</span></p></li>
                <li><p><span style="font-size:10pt;">Supplier failure</span></p></li>
                <li><p><span style="font-size:10pt;">Natural disasters</span></p></li>
                <li><p><span style="font-size:10pt;">Government restrictions</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Where possible we will notify customers and provide alternative arrangements.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">22. Intellectual Property</span></strong></p>

            <p><span style="font-size:10pt;">All content on the Nutrigenic website including logos, branding, text, images, and marketing materials remains the intellectual property of Nutrigenic Group Ltd.</span></p>
            <p><span style="font-size:10pt;">Unauthorised use is prohibited.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">23. Communications</span></strong></p>

            <p><span style="font-size:10pt;">We may communicate with customers regarding orders, subscriptions, promotions, or service updates via:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Email</span></p></li>
                <li><p><span style="font-size:10pt;">Website notifications</span></p></li>
                <li><p><span style="font-size:10pt;">Mobile applications</span></p></li>
            </ul>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">24. Transfer of Rights</span></strong></p>

            <p><span style="font-size:10pt;">Nutrigenic may transfer its rights and obligations under these Terms to another organisation.</span></p>
            <p><span style="font-size:10pt;">This will not affect your legal rights.</span></p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">25. Governing Law</span></strong></p>

            <p><span style="font-size:10pt;">These Terms are governed by the laws of England and Wales.</span></p>
            <p><span style="font-size:10pt;">Any disputes arising from these Terms shall be subject to the jurisdiction of the courts of England and Wales.</span></p>

        </div>
    </div>
</div>